import { TRIAL_MOCK_IDS } from '../constants';

export const getOrganizationListMock = () => [
  {
    id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    name: TRIAL_MOCK_IDS.ORG_NAME,
    display_name: TRIAL_MOCK_IDS.ORG_NAME,
    role: 'organisation_admin',
    type: 'organisation',
    status: 'approved',
    document_status: 'approved',
    role_name: 'Organisation Admin',
    pan: 'ABCDE1234F',
    gstin: '',
    default_branch_id: TRIAL_MOCK_IDS.BRANCH_ID,
    default_branch_name: TRIAL_MOCK_IDS.BRANCH_NAME,
    pan_exists: true,
    is_upgrade_requested: false,
    has_plan: true,
    is_kyc_deferred: false,
    total_member_count: 156,
    image_url: '',
    has_multiple_currencies: false
  }
];

export const getCurrentSubscriptionMock = () => ({
  id: 1,
  organisation_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
  plan_name: 'Pro',
  original_amount: 4999,
  amount_paid: 4999,
  activation_date: '2026-01-01T00:00:00Z',
  start_date: '2026-01-01T00:00:00Z',
  end_date: '2027-01-01T00:00:00Z',
  payer_limit: 500,
  payment_limit: 1000000,
  next_due_amount: 4999,
  payers_added: 156,
  payment_collected: 245600,
  is_lite_plan: false,
  grace_period: 15,
  status: 'active',
  payment_status: 'paid',
  is_assigned_manually: false,
  is_monthly: false,
  is_next_subscription_paid: false,
  is_platform_fee_enabled: false,
  is_trial: false,
  payment_order_id: ''
});

export const getRolesAndPermissionsMock = () => ({
  permissions: [
    'dashboard_view',
    'branch_create',
    'branch_view',
    'branch_edit',
    'group_view',
    'group_create',
    'group_edit',
    'group_disable',
    'group_member_create',
    'group_member_edit',
    'group_member_view',
    'organisation_admin_create',
    'organisation_admin_edit',
    'organisation_admin_view',
    'branch_admin_create',
    'branch_admin_edit',
    'branch_admin_view',
    'group_admin_create',
    'group_admin_edit',
    'group_admin_view',
    'finance_create',
    'finance_edit',
    'finance_view',
    'owner_view',
    'payment_order_generate_report',
    'payment_order_create',
    'payment_order_view',
    'payment_order_send_reminder',
    'payment_order_edit',
    'group_attendance_view',
    'group_attendance_edit',
    'group_attendance_report_download',
    'subscription_view',
    'payment_order_generate_gst_report',
    'branch_member_create',
    'branch_member_edit',
    'branch_member_view',
    'branch_member_delete',
    'event_create',
    'event_edit',
    'event_view',
    'event_status_change',
    'event_ticket_status_change',
    'event_attendee_view',
    'event_attendee_list',
    'integration_edit',
    'member_contact_view',
    'expense_view',
    'create_expense',
    'expense_delete',
    'expense_status_change',
    'lead_view',
    'lead_create',
    'lead_edit',
    'lead_report_generate',
    'lead_bulk_upload',
    'lead_management_config_view',
    'lead_management_config_edit',
    'e_sign_view',
    'e_sign_create'
  ],
  branches: null,
  groups: null
});

export const getUserDetailsMock = () => ({
  user_id: TRIAL_MOCK_IDS.USER_ID,
  name: 'Trial User',
  mobile: '9876543210',
  email: 'trial@acmeacademy.com',
  is_agreement_accepted: true,
  is_welcome_tour_completed: true,
  payment_stats: {
    total_collected: 245600,
    total_due: 34200,
    total_groups: 12,
    total_members: 156
  },
  group_stats: {
    total_groups: 12,
    active_groups: 10
  }
});

export const getAppConfigMock = () => ({
  razorpay_key: '',
  support_email: 'support@cofee.life',
  support_phone: '1800000000',
  min_app_version: '1.0.0',
  maintenance_mode: false,
  supported_phone_number_countries: [
    { dial_code: 91, code: 'IN', name: 'India' }
  ]
});

export const getOrganizationConfigMock = () => ({
  attendance_enabled: true,
  quick_collect_enabled: true,
  event_enabled: true,
  lead_management_enabled: true,
  expense_tracker_enabled: true,
  tally_integration_enabled: false,
  e_sign_enabled: false,
  whatsapp_enabled: true,
  auto_debit_enabled: true,
  daily_cash_enabled: false
});

export const getOrgFeatureFlagsMock = () => [
  'attendance',
  'quick_collect',
  'events',
  'lead_management',
  'expense_tracker',
  'whatsapp',
  'auto_debit'
];

export const getAllBranchesMock = () => ({
  data: [
    {
      id: TRIAL_MOCK_IDS.BRANCH_ID,
      name: TRIAL_MOCK_IDS.BRANCH_NAME,
      organisation_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
      status: 'active',
      is_default: true,
      total_groups: 5,
      total_members: 78
    },
    {
      id: 'trial-branch-002',
      name: 'North Branch',
      organisation_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
      status: 'active',
      is_default: false,
      total_groups: 4,
      total_members: 45
    },
    {
      id: 'trial-branch-003',
      name: 'South Branch',
      organisation_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
      status: 'active',
      is_default: false,
      total_groups: 3,
      total_members: 33
    }
  ]
});

export const getBranchByIdMock = () => ({
  id: TRIAL_MOCK_IDS.BRANCH_ID,
  name: TRIAL_MOCK_IDS.BRANCH_NAME,
  organisation_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
  status: 'active',
  is_default: true,
  total_groups: 5,
  total_members: 78,
  currency: {
    code: 'INR',
    symbol: '\u20B9',
    name: 'Indian Rupee'
  },
  fee_categories: [],
  payment_stats: {
    total_collected: 0,
    total_due: 0
  },
  address_line_1: '12, MG Road',
  address_line_2: '',
  city: 'Bengaluru',
  state: 'Karnataka',
  country: 'India',
  pincode: '560001',
  is_fee_configured: false,
  branch_config: {}
});

export const getDynamicComponentsMock = () => ({
  components: []
});
